import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Depreciation Entry: A financial record tracking the depreciation of assets like buildings and equipment.',
    name: 'Depreciation',
    partialId: PartialId.Standard.create('deprec'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
